/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InfoEntryType {
  ProductionOrder = 'ProductionOrder',
  ProductionOrderKpi = 'ProductionOrderKpi',
  Shift = 'Shift',
  Downtime = 'Downtime',
  ContainerLabelInfo = 'ContainerLabelInfo',
  CheckResult = 'CheckResult'
}
